import { useState, useEffect } from 'react';
import { parse } from 'date-fns';
import { styles } from './shared';
import { isRunning, isDone } from './shared';

const toDiff = (start, end) => ({
  start,
  end,
  diff: start && end ? end - start : null,
});

const useRunningRuntime = (job) => {
  const [start, setStart] = useState();
  const [end, setEnd] = useState(new Date().getTime());

  useEffect(() => {
    if (!job?.id) {
      return;
    }
    setStart(new Date(job.createdAt).getTime());
  }, [job?.id]);

  useEffect(() => {
    const id = setInterval(() => {
      setEnd(new Date().getTime());
    }, 30);
    return () => clearInterval(id);
  }, []);

  return toDiff(start, end);
};

const useDoneRuntime = (job) => {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  useEffect(() => {
    if (!job?.id) {
      return;
    }
    setStart(new Date(job.createdAt).getTime());
    setEnd(new Date(job.updatedAt).getTime());
  }, [job?.id, job?.createdAt, job?.updatedAt]);

  return toDiff(start, end);
};

export const Runtime = ({ job }) => {
  const [type, setType] = useState('done');
  const running = useRunningRuntime(job);
  const done = useDoneRuntime(job);
  const [counts, setCounts] = useState({
    started: 0,
    completed: 0,
  });

  useEffect(() => {
    const j = job?.children || [];
    const d = (job?.children || []).filter((it) => isDone(it.state));
    setCounts({
      started: j.length,
      completed: d.length,
    });
  }, [job?.children]);

  useEffect(() => {
    if (!job?.id || !job?.state) {
      return;
    }

    if (['completed', 'failed'].includes(job?.state) && done?.diff !== undefined) {
      setType('done');
    } else {
      setType('running');
    }
  }, [job?.id, job?.state, done?.diff]);

  if (!type) {
    return null;
  }

  const diff = {
    running: running.diff,
    done: done.diff,
  }[type];

  const fontSize = 11;

  const mono = isRunning(job?.state) ? styles.mono : {};

  return [
    counts.started ? (
      <div key="1" style={{ ...mono, fontSize }}>
        {counts.completed}/{counts.started} {counts.started == 1 ? 'job' : 'jobs'}
        {diff ? ',' : ''}
      </div>
    ) : null,
    <div key="2" style={{ ...mono, fontSize }}>
      {diff ? (diff / 1000).toFixed(2) + 's' : ''}
    </div>,
  ];
};
